import * as React from 'react';
import { GlobalProps } from 'lib/app/global-props';
import { Startup } from 'lib/api/startup';
import {
    hotpanelApi,
    setGlobalProps,
    setScreenName,
    setStartup,
    HotpanelApi,
} from 'lib/hotpanel/hotpanel-api';

type Props = {
    children: React.ReactNode;
    globalProps: GlobalProps;
    startup?: Promise<Startup>;
};

const HotpanelContext = React.createContext<{
    hotpanel: HotpanelApi;
    setScreenName: typeof setScreenName;
}>({
    hotpanel: hotpanelApi,
    setScreenName,
});

export const HotpanelProvider: React.FC<Props> = ({ children, globalProps, startup }) => {
    React.useEffect(() => {
        setGlobalProps(globalProps);
    }, [globalProps]);

    React.useEffect(() => {
        startup?.then((data) => {
            setStartup(data);
        });
    }, [startup]);

    React.useEffect(() => {
        const unloadHandler = () => {
            hotpanelApi.flush();
        };

        window.addEventListener('beforeunload', unloadHandler);

        return () => {
            window.removeEventListener('beforeunload', unloadHandler);
        };
    }, []);

    return (
        <HotpanelContext.Provider
            value={{
                hotpanel: hotpanelApi,
                setScreenName,
            }}
        >
            {children}
        </HotpanelContext.Provider>
    );
};

export const useHotpanel = () => React.useContext(HotpanelContext);
